module.exports = __webpack_public_path__ + "assets/img/AppIcon.a29cae91.png";